import React from "react";
import './TodoError.css'

function TodoError(){
    return(
        <p>Error</p>
    )
}
export { TodoError };